import Interceptor from "@/plugins/interceptor.js"

const urlAPI = `${process.env.VUE_APP_API_URL_INFO}${process.env.VUE_APP_API_INFO}`

let intervalGameStat = null;
const Info = {
  state: {
    publishedGames: [],
    publishedEditorial: [],
    selectGame: {},
    gameStat: {},
    avatars: [],
    teams: [],
    config: {},
    banner: null,
    publishedGamesAnon: [],
    advertising: []
  },
  actions: {
    getPublishedGames: async ({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getPublishedGames`)
        commit('SET_publishedGames', response.data)
        // Clear states
        commit('SET_selectGame', {})
        commit('SET_avatars', [])
        commit('SET_gameStat', {})
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getPublishedEditorialCards: async ({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getPublishedEditorialCards`)
        commit('SET_publishedEditorial', response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getGame: async({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getGame?gameId=${params.id}`)
        commit('SET_selectGame', response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getAvatars: async({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getAvatars?teamId=${params.id}`)
        commit('SET_avatars', response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getTeams: async({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getTeams`)
        commit('SET_teams', response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getSurvey: async(_, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getSurvey?surveyId=${params.surveyId}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getGameStat: async({commit}, params) => {
      async function callGameStat() {
        const response = await Interceptor.get(`${urlAPI}/getGameStat?gameId=${params.id}&teamId=${params.teamId}`, 2000)
        if (response && response.status == 200) {
          commit('SET_gameStat', response.data)
        }
        return response;
      }
      // Verify interval clean
      if (intervalGameStat != null) {
        try {
          clearInterval(intervalGameStat)
          intervalGameStat = null
        } catch (error) {
          console.error(error)
        }
      }

      // First call (without await)
      callGameStat()

      try {
        intervalGameStat = setInterval(async () => {
          await callGameStat()
        }, 5000)
      } catch (error) {
        console.error(error)
      }
    },
    gameActionDetail: async(_, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/gameActionDetail?id=${params.id}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    destroyGameStat: () => {
      clearInterval(intervalGameStat)
    },
    setGameSelect: ({commit}, data) => {
      commit('SET_selectGame', data)
    },
    getClientConfig: async ({commit, state}) => {
      try {
        if (Object.keys(state.config).length > 0) {
          return state.config
        } else {
          const response = await Interceptor.get(`${urlAPI}/getClientConfig`)
          commit("SET_config", response.data)
          return response.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    getBanner: async ({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getBanner`)
        commit("SET_banner", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getStoreLinks: async () => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getStoreLinks`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getPublishedGamesAnon: async ({commit}) => {
      try {
        const response = await Interceptor.getWithoutToken(`${urlAPI}/getPublishedGamesAnon`)
        commit('SET_publishedGamesAnon', response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getAdvertising: async ({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getAdvertising?gameId=${params.id}&teamId=${params.teamId}`)
        commit("SET_advertising", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
    SET_publishedGames(state, data) {
      state.publishedGames = data
    },
    SET_selectGame(state, data) {
      state.selectGame = data
    },
    SET_gameStat(state, data) {
      state.gameStat = data
    },
    SET_avatars(state, data) {
      state.avatars = data
    },
    SET_teams(state, data) {
      state.teams = data
    },
    SET_publishedEditorial(state, data) {
      state.publishedEditorial = data
    },
    SET_config(state, data) {
      state.config = data
    },
    SET_banner(state, data) {
      state.banner = data
    },
    SET_publishedGamesAnon(state, data) {
      state.publishedGamesAnon = data
    },
    SET_advertising(state, data) {
      state.advertising = data
    }
  }
}

export default Info